/** @format */

import React from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import Loader from "../../Components/Loader";
import masterServices from "../../Services/masterService";

export const EditStorage = () => {
  const history = useHistory();
  // const [loader, setLoader] = useState(false);
  // const [data, setData] = useState();
  const param = history.location.state;

  // console.log("param", param);
  const initialValues = {
    storage_data: param.data.storages,
    minimum: param.data.minimum,
  };
  // const validationSchema = Yup.object().shape({
  //   storage_data: Yup.array().of(
  //     Yup.object().shape({
  //       tarrif: Yup.string().required("Required"),
  //       rate: Yup.string().required("Required"),
  //       uom: Yup.string().required("Required"),
  //     })
  //   ),
  //   mini: Yup.string().required("Required"),
  // });

  const onSubmit = (fields) => {
    let postData = {
      storages: fields.storage_data,
      minimum: fields.minimum,
    };
    console.log(postData, "postData");
    masterServices.add_storage(postData).then((res) => {
      console.log("res", res);

      if (res.status) {
        history.push("/storage-list");
        toast.success("Storage update successfully");
      } else {
        toast.error(res.message);
      }
    });
  };
  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="row">
            <div className="col-6">
              <div className="card-body">
                <Formik
                  initialValues={initialValues && initialValues}
                  onSubmit={onSubmit}
                >
                  {({ errors, values, touched }) => (
                    <Form className="control-form">
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-4">
                              <label>Tariff</label>
                            </div>
                            <div className="col-2">
                              <label>Rate/aed</label>
                            </div>
                            <div className="col-4">
                              <label>UOM</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <FieldArray name="storage_data.storages">
                        {() =>
                          values.storage_data &&
                          values.storage_data.map((ticket, i) => {
                            const ticketErrors =
                              (errors.storage_data?.length &&
                                errors.storage_data[i]) ||
                              {};
                            const ticketTouched =
                              (touched.storage_data?.length &&
                                touched.storage_data[i]) ||
                              {};
                            return (
                              <div className="row bg-light mb-3">
                                <div className="col-md-12 my-3">
                                  <div className="row">
                                    <div className="col-4">
                                      <Field
                                        name={`storage_data.${i}.tarrif`}
                                        type="text"
                                        className={
                                          "form-control" +
                                          (ticketErrors.tarrif &&
                                          ticketTouched.tarrif
                                            ? " is-invalid"
                                            : "")
                                        }
                                        readOnly
                                      />
                                      <ErrorMessage
                                        name={`storage_data.${i}.tarrif`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    <div className="col-2">
                                      <Field
                                        name={`storage_data.${i}.rate`}
                                        type="number"
                                        className={
                                          "form-control" +
                                          (ticketErrors.rate &&
                                          ticketTouched.rate
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name={`storage_data.${i}.rate`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                    <div className="col-4">
                                      <Field
                                        name={`storage_data.${i}.UOM`}
                                        type="text"
                                        className={
                                          "form-control" +
                                          (ticketErrors.UOM && ticketTouched.UOM
                                            ? " is-invalid"
                                            : "")
                                        }
                                        readOnly
                                      />
                                      <ErrorMessage
                                        name={`storage_data.${i}.UOM`}
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        }
                      </FieldArray>
                      <div className="row mb-4">
                        <div className="col-4">
                          <label>Overall Total Minimum</label>
                        </div>
                        <div className="col-6">
                          {console.log(values)}
                          <Field
                            name="minimum"
                            type="number"
                            className="form-control"
                            value={values.minimum}
                          />
                          <ErrorMessage
                            name={`values.minimum`}
                            component="div"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          <button
                            className="btn btn-danger w-sm waves-effect waves-light"
                            type="button"
                            onClick={() => history.goBack()}
                          >
                            Back
                          </button>
                        </div>
                        <div className="col-4 text-end">
                          <button
                            className="btn btn-primary w-sm waves-effect waves-light"
                            type="submit"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
